import firebase from 'firebase/app'
import 'firebase/auth'
import config from '@/config/firebase'
export const auth = (!firebase.apps.length) ? firebase.initializeApp({ ...config, }).auth():firebase.app().auth()
